import React, { useState, useEffect, useRef, useContext } from "react";
import Select from "react-select";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";

const apiUrl = process.env.REACT_APP_API_URL;
// const cardOptions = [
//   {
//     id: "A",
//     value: "66d31e6e8b6cb953390002",
//     label: "Credit Card",
//   },
//   { id: "B", value: "66d31e6550e23909435696", label: "Debit Card" },
// ];


const cardOptions = [
  {
    id: "A",
    value: "66d31e6e8b6cb953390002",
    labels: {
      en: "Credit Card",
      Hi: "क्रेडिट कार्ड",
      Kn: "ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್",
    },
  },
  {
    id: "B",
    value: "66d31e6550e23909435696",
    labels: {
      en: "Debit Card",
      Hi: "डेबिट कार्ड",
      Kn: "ಡೆಬಿಟ್ ಕಾರ್ಡ್",
    },
  },
];


const customStyles = {
  container: (provided) => ({
    ...provided,
    width: "450px",
    height: "24px",
    "@media (max-width: 768px)": {
      width: "300px",
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    maxHeight: "180px",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "180px",
    overflowY: "auto",
    fontSize: "16px",
  }),
  control: (provided) => ({
    ...provided,
    minHeight: "30px",
    height: "30px",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    height: "14px",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "8px",
    svg: {
      width: "18px",
      height: "18px",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "14px",
    marginBottom: "10px",
    color: "#004999",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "16px",
    marginBottom: "10px",
    color: "#004999",
  }),
  input: (base) => ({
    ...base,
    padding: "0px",
  }),
};

const translations = {
  en: {
    selectLanguage: "Select Language:",
    bankDetailsTitle: "Your Bank Details",
    subCategoryLabel: "Sub Category:",
    subCategoryPlaceholder: "Select Sub Category",
    selectBankLabel: "Select the Bank:",
    modeOfPaymentLabel: "Mode Of Payment:",
    walletListLabel: "Wallet/PG/PA List:",
    accountNoLabel: "Account No/ Credit/Debit Card No:",
    accountNoPlaceholder: "Enter Account No.",
    selectPlaceholder: "Select...",
    ok: "OK",
  },
  Hi: {
    selectLanguage: "भाषा चुनें:",
    bankDetailsTitle: "आपके बैंक विवरण",
    subCategoryLabel: "उप-श्रेणी:",
    subCategoryPlaceholder: "बैंक चुनें",
    selectBankLabel: "बैंक चुनें:",
    modeOfPaymentLabel: "भुगतान का तरीका:",
    walletListLabel: "वॉलेट/पीजी/पीए सूची:",
    accountNoLabel: "खाता संख्या/ क्रेडिट/डेबिट कार्ड संख्या:",
    accountNoPlaceholder: "खाता संख्या दर्ज करें।",
    selectPlaceholder: "चुनें...",
    ok: "ठीक है",
  },
  Kn: {
    selectLanguage: "ಭಾಷೆ ಆಯ್ಕೆ ಮಾಡಿ:",
    bankDetailsTitle: "ನಿಮ್ಮ ಬ್ಯಾಂಕ್‌ ಖಾತೆಯ ವಿವರಗಳು.",
    subCategoryLabel: "ಉಪ ವರ್ಗ :",
    subCategoryPlaceholder: "ಉಪ ವರ್ಗ ಅಯ್ಕೆ ಮಾಡಿ",
   selectBankLabel: "ನಿಮ್ಮ ಬ್ಯಾಂಕ್‌ ಆಯ್ಕೆ ಮಾಡಿ.",
    modeOfPaymentLabel: "ಪಾವತಿ ವಿಧಾನ:",
    walletListLabel: "ವಾಲೆಟ್/ಪಿಜಿ/ಪಿಎ ಪಟ್ಟಿ:",
    accountNoLabel: "ಖಾತೆ ಸಂಖ್ಯೆ / ಕ್ರೆಡಿಟ್‌ ಕಾರ್ಡ್ / ಡೆಬಿಟ್ ಕಾರ್ಡ್ ಸಂಖ್ಯೆ:",
    accountNoPlaceholder: "ಖಾತೆ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ.",
    selectPlaceholder: "ಆಯ್ಕೆ ಮಾಡಿ...",
    ok: "ಸರಿ",
  },
  tulu: {
    selectLanguage: "ಭಾಷೆ ಆಯ್ಕೆ ಮಾಡಿ:",
    bankDetailsTitle: "ನಿಂದು ಬ್ಯಾಂಕ್ ವಿವರ",
    subCategoryLabel: "ಉಪ-ವರ್ಗ:",
    subCategoryPlaceholder: "ಬ್ಯಾಂಕ್ ಆಯ್ಕೆಮಾಡ್",
    selectBankLabel: "ಬ್ಯಾಂಕ್ ಆಯ್ಕೆಮಾಡ್:",
    modeOfPaymentLabel: "ಪಾವತಿ ವಿಧಾನ:",
    walletListLabel: "ವಾಲೆಟ್/ಪಿಜಿ/ಪಿಎ ಪಟ್ಟಿ:",
    accountNoLabel: "ಖಾತೆ ಸಂಖ್ಯೆ/ ಕ್ರೆಡಿಟ್/ಡೆಬಿಟ್ ಕಾರ್ಡ್ ಸಂಖ್ಯೆ:",
    accountNoPlaceholder: "ಖಾತೆ ಸಂಖ್ಯೆ ನಮೂದ ಮಲ್ಪು.",
    selectPlaceholder: "ಆಯ್ಕೆ ಮಲ್ಪು...",
    ok: "ಸರಿ",
  },
};

const VictimBank = ({
  onNext,
  onSuspectBankSelected,
  addVictimBank,
  index,
  onQuestion,
  apiKey,
  botToken,
  vist_id,
  app_ver,
  selectedLang
}) => {
  const [typeOptions, setTypeOptions] = useState([]);
  const [walletOption, setWalletOptions] = useState([]);
  const [rawBankData, setRawBankData] = useState(null);
  const [rawTypeData,setRawTypeData] = useState(null);
  const [rawWalletData, setRawWalletData] = useState(null);
  const [formData, setFormData] = useState({
    sub_cat: "",
    bank_name: "",
    acc_no: "",
    mod_op: "",
    wallet_list: "",
  });
  const [bankOption, setBankOptions] = useState([]);
  const [error, setError] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);

  const audioRef = useRef(null);
  const audioMap = {
    en: "audio/English BOT Audios/victimbank.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio5.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio5.m4a",
    tcy: "audio/cybervictim_tcy.mp3"
  };


  useEffect(() => {
    const storedDistrict = localStorage.getItem("victimBank");
    if (storedDistrict) {
      const data = JSON.parse(storedDistrict);
      setFormData((prev) => ({
        ...prev,
        bank_name: data.bank_name || "",
        acc_no: data.acc_no || "",
        sub_cat: data.sub_cat || "",
        mod_op: data.mod_op || "",
        wallet_list: data.wallet_list,
      }));
    }
  }, []);


  const getBankList = (resp, language) => {
    switch (language) {
      case "en":
        return resp.lang_eng;
      case "Hi":
        return resp.lang_hin;
      case "Kn":
        return resp.lang_kanada;
      default:
        return resp.lang_eng; // fallback
    }
  };


  useEffect(() => {
    if (rawBankData) {
      const ProfessionList = getBankList(rawBankData, selectedLang) || [];
      setBankOptions(
        ProfessionList.map((profession, index) => ({
          id: String.fromCharCode(65 + index),
          value: profession.bwpa_uniq,
          label: profession.bwpa_nm,
        })) || []
      );
    }
  }, [selectedLang, rawBankData]);


  useEffect(() => {
    const fetchBankData = async () => {
      try {
        const BankResponse = await fetch(
          `${apiUrl}/v1/cy_ma_bank_wlet_pg_pa_list`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              api_key: apiKey,
              visitor_token: vist_id,
              qtion_id: "66f6544451d1f",
              lac_token: botToken,
              app_ver: app_ver,
              bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
            }),
          }
        );
        if (!BankResponse.ok) {
          throw new Error("Failed to fetch bank options");
        }
        const BankData = await BankResponse.json();
        setRawBankData(BankData.resp);
        // setBankOptions(
        //   BankData.resp.bank_wlet_pg_pa_list.map((bank) => ({
        //     value: bank.bwpa_uniq,
        //     label: bank.bwpa_nm,
        //   })) || []
        // );
      } catch (error) {
        console.error("Error fetching bank options:", error);
      }
    };

    fetchBankData();
  }, [app_ver, apiKey, botToken, vist_id]);

  useEffect(() => {
    if (rawTypeData) {
      const ProfessionList = getBankList(rawTypeData, selectedLang) || [];
      setTypeOptions(
        ProfessionList.map((profession, index) => ({
          id: String.fromCharCode(65 + index),
          value: profession.subcat_uni,
          label: profession.subcat_nm,
        })) || []
      );
    }
  }, [selectedLang, rawTypeData]);

    useEffect(() => {
      if (rawWalletData) {
        const ProfessionList = getBankList(rawWalletData, selectedLang) || [];
        setWalletOptions(
          ProfessionList.map((profession, index) => ({
            id: String.fromCharCode(65 + index),
            value: profession.wpa_uniq,
            label: profession.wpa_nm,
          })) || []
        );
      }
    }, [selectedLang, rawWalletData]);

  useEffect(() => {
    const fetchBankData = async () => {
      try {
        const BankResponse = await fetch(
          `${apiUrl}/v1/cy_ma_sub_category_list`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              api_key: apiKey,
              visitor_token: vist_id,
              qtion_id: "66f6544451d1f",
              lac_token: botToken,
              bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
            }),
          }
        );
        if (!BankResponse.ok) {
          throw new Error("Failed to fetch sub-category options");
        }
        const BankData = await BankResponse.json();
        setRawTypeData(BankData.resp);
        // setTypeOptions(
        //   BankData.resp.sub_category_list.map((bank) => ({
        //     value: bank.subcat_uni,
        //     label: bank.subcat_nm,
        //   })) || []
        // );
      } catch (error) {
        console.error("Error fetching sub-category options:", error);
      }
    };

    const fetchWalletData = async () => {
      try {
        const BankResponse = await fetch(`${apiUrl}/v1/cy_ma_wlet_pg_pa_list`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            api_key: apiKey,
            visitor_token: vist_id,
            qtion_id: "66f6545af3d6e",
            lac_token: botToken,
            app_ver: app_ver,
            bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
          }),
        });
        if (!BankResponse.ok) {
          throw new Error("Failed to fetch wallet options");
        }
        const BankData = await BankResponse.json();
        setRawWalletData(BankData.resp);
        // setWalletOptions(
        //   BankData.resp.wlet_pg_pa_list.map((bank) => ({
        //     value: bank.wpa_uniq,
        //     label: bank.wpa_nm,
        //   })) || []
        // );
      } catch (error) {
        console.error("Error fetching wallet options:", error);
      }
    };

    fetchWalletData();
    fetchBankData();
  }, [apiKey, app_ver, botToken, vist_id]);

  const handleSelectChange = (field, selectedOption) => {
    if (field === "sub_cat") {
      if (selectedOption.value === "66d300879af61335355481") {
        setFormData((prev) => {
          const updated = {
            ...prev,
            [field]: selectedOption ? selectedOption.value : "",
            wallet_list: "",
            bank_name: "",
          };
          setFormData(updated);
          return updated;
        });
      } else if (selectedOption.value === "66d300879af44537699255") {
        setFormData((prev) => {
          const updated = {
            ...prev,
            [field]: selectedOption ? selectedOption.value : "",
          };
          setFormData(updated);
          return updated;
        });
      } else {
        setFormData((prev) => {
          const updated = {
            ...prev,
            [field]: selectedOption ? selectedOption.value : "",
            mod_op: "",
            wallet_list: "",
            bank_name: "",
          };
          setFormData(updated);
          return updated;
        });
      }
    }
    if (field === "mod_op") {
      if (selectedOption.value !== "66d31e6e8b6cb953390002") {
        setFormData((prev) => {
          const updated = { ...prev, [field]: selectedOption ? selectedOption.value : "" };
          setFormData(updated);
          return updated;
        });
      }
    }
    setFormData((prev) => {
      const updated = { ...prev, [field]: selectedOption ? selectedOption.value : "" };
      setFormData(updated);
      return updated;
    });
  };

  const handleTextChange = (id, value) => {
    let updated;
    if (id === "acc_no") {
      if (/^[a-zA-Z0-9\s]*$/.test(value) && value.length <= 50) {
        updated = { ...formData, [id]: value };
        setFormData(updated);
      } else {
        if (value.length > 50) {
          setError("Account number must be less than 50 characters.");
        }
      }
    } else if (id === "transaction_no") {
      if (/^[a-zA-Z0-9\s]*$/.test(value) && value.length <= 50) {
        updated = { ...formData, [id]: value };
        setFormData(updated);
        if (value.length < 10) {
          setError("Transaction number must be at least 10 characters long.");
        } else {
          setError("");
        }
      } else {
        if (value.length > 50) {
          setError("Transaction number must be less than 50 characters.");
        }
      }
    } else if (id === "amt") {
      if (/^\d*\.?\d*$/.test(value)) {
        updated = { ...formData, [id]: value };
        setFormData(updated);
        setError("");
      } else {
        setError("Amount can only contain numbers and a decimal point.");
      }
    } else if (id === "ref_num") {
      if (/^[a-zA-Z0-9\s]*$/.test(value) && value.length <= 100) {
        updated = { ...formData, [id]: value };
        setFormData(updated);
        if (value.length < 5) {
          setError("Reference number must be at least 5 characters long.");
        } else {
          setError("");
        }
      } else {
        if (value.length > 50) {
          setError("Reference number must be less than 50 characters.");
        }
      }
    } else {
      updated = { ...formData, [id]: value };
      setFormData(updated);
      setError("");
    }
  };

  const handleOkClick = async (e) => {
    e.preventDefault();
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    if (formData.sub_cat && formData.bank_name && formData.acc_no) {
      if (formData.acc_no.length <= 5) {
        setError("Please Enter the valid account number.");
        return;
      }
      try {
        const response = await fetch(`${apiUrl}/v1/ccrim_bot_add_victim_trans`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            api_key: apiKey,
            visitor_token: vist_id,
            qtion_id: "66f6544451d1f",
            qtion_num: "3",
            bank_mer: formData.bank_name,
            acc_no: formData.acc_no,
            lac_token: botToken,
            app_ver: app_ver,
            mod_op: formData.mod_op,
            wallet_list: formData.wallet_list,
            sub_cat: formData.sub_cat,
            bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
          }),
        });
        if (!response.ok) {
          throw new Error("Failed to submit form data.");
        }
        const responseData = await response.json();
        if (responseData.resp.error_code === "0") {
          onNext(4);
          onQuestion(5);
          localStorage.setItem("victimBank", JSON.stringify(formData));
        }
      } catch (error) {
        console.error("Error submitting form data:", error);
        setError("Failed to submit form data. Please try again.");
      }
    }
    onNext(4);
    onQuestion(5);
  };

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };  
      useEffect(() => {
        if (audioRef.current) {
          // Update the audio source and reload the element
          audioRef.current.src = audioMap[selectedLang] || audioMap["en"];
          audioRef.current.load();
          // If audio was playing, continue playing the new audio
          if (isPlaying) {
            audioRef.current.play();
          }
        }
      }, [selectedLang, isPlaying]);

           useEffect(() => {
               const handler = () => {
                if (audioRef.current) {
                   audioRef.current.pause();
                   audioRef.current.currentTime = 0;
                    setIsPlaying(false);
                  }
                };
                window.addEventListener('pauseAllAudio', handler);
                return () => window.removeEventListener('pauseAllAudio', handler);
              }, []);

      const getTranslatedCardOptions = (lang) =>
        cardOptions.map((option) => ({
          value: option.value,
          label: option.labels[lang] || option.labels.en, // fallback to English
        }))
        
  return (
    <div className="question">
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{zIndex: "1000"}}>
          <div style={{ textAlign: "center" }}>
            <div style={{ display: "flex" }}>
              <h2>{translations[selectedLang].bankDetailsTitle}</h2>
              <button onClick={toggleAudio} className="audio-button">
                {isPlaying ? <FaPause color="White" size={12} style={{ marginBottom: '20px' }} /> : <FaPlay color="White" size={12} style={{ marginBottom: '20px' }}/>}
              </button>
            </div>
            <audio ref={audioRef} onEnded={handleAudioEnd}>
              <source src={audioMap[selectedLang]} type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
          </div>
          <div className="name-list">
            <p className="bank-para">{translations[selectedLang].subCategoryLabel}</p>
            <Select
              value={typeOptions.find((bank) => bank.value === formData.sub_cat)}
              onChange={(selectedOption) => handleSelectChange("sub_cat", selectedOption)}
              options={typeOptions}
              className="dropdown-input"
              placeholder={translations[selectedLang].subCategoryPlaceholder}
              styles={customStyles}
            />
            <p className="bank-para" style={{ marginTop: "20px" }}>
              {translations[selectedLang].selectBankLabel}
            </p>
            <Select
              value={
                formData.sub_cat === "66d300879af5f216270004"
                  ? walletOption.find((Bank) => Bank.value === formData.bank_name) || null
                  : formData.sub_cat !== "66d300879af5f216270004"
                  ? bankOption.find((Wallet) => Wallet.value === formData.bank_name) || null
                  : null
              }
              onChange={(selectedOption) => handleSelectChange("bank_name", selectedOption)}
              options={formData.sub_cat === "66d300879af5f216270004" ? walletOption : bankOption}
              className="dropdown-input"
              placeholder={
                formData.sub_cat === ""
                  ? translations[selectedLang].subCategoryPlaceholder
                  : translations[selectedLang].selectPlaceholder
              }
              isDisabled={!formData.sub_cat}
              styles={customStyles}
            />
            {formData.sub_cat === "66d300879af61335355481" && (
              <>
                <p className="bank-para" style={{ marginTop: "20px" }}>
                  {translations[selectedLang].modeOfPaymentLabel}
                </p>
                <Select
                    value={getTranslatedCardOptions(selectedLang).find(
    (Merchant) => Merchant.value === formData.mod_op
  )}
                  onChange={(selectedOption) => handleSelectChange("mod_op", selectedOption)}
                  options={getTranslatedCardOptions(selectedLang)}
                  className="dropdown-input"
                  placeholder={translations[selectedLang].selectPlaceholder}
                  styles={customStyles}
                />
              </>
            )}
            {formData.sub_cat === "66d300879af44537699255" && (
              <>
                <p className="bank-para" style={{ marginTop: "20px" }}>
                  {translations[selectedLang].walletListLabel}
                </p>
                <Select
                  value={walletOption.find((Merchant) => Merchant.value === formData.wallet_list)}
                  onChange={(selectedOption) => handleSelectChange("wallet_list", selectedOption)}
                  options={walletOption}
                  className="dropdown-input"
                  placeholder={translations[selectedLang].selectPlaceholder}
                  styles={customStyles}
                />
              </>
            )}
            <p className="bank-para" style={{ marginTop: "20px" }}>
              {translations[selectedLang].accountNoLabel}
            </p>
            <input
              type="text"
              className="text-input account"
              style={{backgroundColor:'transparent'}}
              name="acc_no"
              onChange={(e) => handleTextChange("acc_no", e.target.value)}
              value={formData.acc_no}
              autoComplete="off"
              placeholder={translations[selectedLang].accountNoPlaceholder}
            />
          </div>
          <div style={{ display: "flex", position: "relative", zIndex: "9" }}>
            <button type="button" className="ok-btn" onClick={handleOkClick}>
              {translations[selectedLang].ok}
            </button>
          </div>
        </div>
        {error && (
          <p
            style={{
              color: "red",
              marginTop: "10px",
              position: "relative",
              zIndex: "1000",
            }}
          >
            {error}
          </p>
        )}
      </div>
    </div>
  );
};

export default VictimBank;
